export const buildTime = '2026-10-22 10:05:21 UTC';
